import { c as _c } from "react/compiler-runtime";
import { classNames, SkeletonBlock } from "@opensea/ui-kit";
import { range } from "es-toolkit/math";
function ItemAttributesGridItemSkeleton(t0) {
  const $ = _c(4);
  const {
    overrides
  } = t0;
  const t1 = overrides?.Skeleton?.className;
  let t2;
  if ($[0] !== t1) {
    t2 = classNames("col-span-4 h-[110px] overflow-hidden rounded-lg border border-border-1", t1);
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== t2) {
    t3 = <SkeletonBlock className={t2} />;
    $[2] = t2;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  return t3;
}
export function ItemAttributesGridSkeleton(t0) {
  const $ = _c(7);
  const {
    number: t1,
    overrides
  } = t0;
  const number = t1 === undefined ? 9 : t1;
  let t2;
  if ($[0] !== number || $[1] !== overrides) {
    let t3;
    if ($[3] !== overrides) {
      t3 = index => <ItemAttributesGridItemSkeleton key={`ItemAttributesGridItemSkeleton-${index.toString()}`} overrides={overrides} />;
      $[3] = overrides;
      $[4] = t3;
    } else {
      t3 = $[4];
    }
    t2 = range(number).map(t3);
    $[0] = number;
    $[1] = overrides;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[5] !== t2) {
    t3 = <div className="grid w-full grid-cols-12 gap-3">{t2}</div>;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  return t3;
}